import store_config from '@/store/mods/parametres/config'

export default {
    name: 'manage-lits',
    components: {},
    props: {
        toggler_lit: Number,
        selected_chambre: {
            type: Object,
            default: () => {}
        }
    },

    watch: {
        toggler_lit() {
            this.is_liste = true
            this.libelle_lit = ''
            this.clearError()
        }
    },

    data() {
        return {
            modal_title: 'Liste des lits',
            is_liste: true,
            deleting_items: [],
            save_loading: false,
            is_confirm: false,
            confirm_msg: '',
            msg_error: '',

            libelle_lit: '',
            field_is_empty: false,
            selected_lit: {
                id: 0,
                libelle: ''
            }
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        toggleListView(value) {
            this.clearError()
            this.is_liste = (value == 0)?false:true
            this.libelle_lit = ''
            this.deleting_items = []
        },

        onConfirm() {
            this.confirm_msg = ""
        },

        clearError() {
            this.field_is_empty = false
            this.msg_error = ""
            this.confirm_msg = ""
            this.is_confirm = false
        },


        deleteLit(selector) {
            if (!this.is_confirm) {
                this.is_confirm = true
                return;
            }

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                this.confirm_msg = "Merci de confirmer la suppression des lits"
                return
            }

            console.log("Del: ",this.deleting_items);
            this.save_loading = true
            store_config.deleteLits(this.deleting_items).then((response) => {
                if (response.success) {
                    this.$refs.manage_lit.click()
                    this.$emit("emitChambre")
                    this.successToast(response.message)
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite !"
            })
        },

        editLit(data) {
            this.is_liste = false
            this.selected_lit = {
                id: data.id,
                libelle: data.libelle
            }
            this.libelle_lit = data.libelle
        },

        submit() {
            if (this.libelle_lit == '') {
                this.field_is_empty = true
                return;
            }

            const data = {
                id: this.selected_lit.id,
                libelle: this.libelle_lit,
                chambre_id: this.selected_chambre.admission_id
            }

            this.save_loading = true
            store_config.saveLit(data).then((response) => {
                if (response.success) {
                    this.$refs.manage_lit.click()
                    this.$emit("emitChambre")
                    this.successToast(response.message)
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite !"
            })
        }
    }
}